(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteController', ReportExecuteController);

    ReportExecuteController.$inject = ['$scope', '$state', 'ReportExecute', 'ReportExecuteSearch'];

    function ReportExecuteController ($scope, $state, ReportExecute, ReportExecuteSearch) {
        var vm = this;

        vm.reportExecutes = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ReportExecute.query(function(result) {
                vm.reportExecutes = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ReportExecuteSearch.query({query: vm.searchQuery}, function(result) {
                vm.reportExecutes = result;
            });
        }    }
})();
